import { Box, Typography } from '@material-ui/core';
import { useEffect, useMemo, useState } from 'react';
import React from 'reactn';
import Hoverable from '../../../hoverable';
import { VoiceCallService } from '../../services/voice-call.service';
import moment from 'moment-timezone';
import { VOICE_CALL } from '../../constants/voice-call-constants';
import { LOCATIONS } from '../../../../constants';
import { columnSortByOrderDirection } from '../../../../util/Helpers';
import { getCallStatusComponents, getCallType, getSelectedLocationTimeZone, getVoiceInsights } from '../../utils/utils';
import VoiceInsightChip from '../voice-insight-chip/voice-insight-chip';
import { InfoOutlined } from '@mui/icons-material';
import { Button } from '@orijinworks/frontend-commons';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import CallIcon from '@mui/icons-material/Call';
import { ViewDetailStyles } from './call-history.component.style';
import useUnleashHook from '../../../../v2/core/unleash/useUnleashHook';
import { UnleashService } from '../../../../v2/services';
export const useCallHistoryListComponentHook = (props, isKeywordFlagEnabled) => {
  const isV2CallHistoryFlagEnabled = useUnleashHook(UnleashService.FLAGS.V2_CALL_HISTORY).isFlagEnabled();
  const [defaultPageSize, setDefaultPageSize] = useState(10);
  const voiceCallService = new VoiceCallService();
  const [callsData, setCallsData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [isDetailModalOpen, setDetailModalState] = useState(false);
  const [callDetails, setCallDetails] = useState({});
  const [recordingUrl, setRecordingUrl] = useState(null);
  const [callStatus, setCallStatus] = useState('');
  const [transcriptData, setTranscriptData] = useState([]);
  const [detectedKeywords, setDetectedKeywords] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarAutoHideDuration, setSnackbarAutoHideDuration] = useState(3000);
  const [isSuccessSnackbar, setIsSuccessSnackbar] = useState(true);
  const tableRef = React.useRef();
  const [isPrivileged, setIsPrivileged] = useState(false);
  const [transcriptSummary, setTranscriptSummary] = useState({
    main_topics: '',
    inappropriate_violent_themes: [],
  });
  const [stateFilters, setStateFilters] = useState({
    learnerFirstName: '',
    learnerDocId: '',
    relationshipType: '',
    contactPhoneNumber: '',
    contactName: '',
    endTimeUtc: '',
    callState: [],
    voiceCallInsights: [],
  });
  const [allowedFilters, setAllowedFilters] = useState([
    'learnerFirstName',
    'learnerDocId',
    'relationshipType',
    'contactPhoneNumber',
    'contactName',
    'endTimeUtc',
    'callState',
    'voiceCallInsights',
  ]);
  const [queryForExport, setQueryForExport] = useState([]);
  // V2
  const [page, setPage] = useState(1);
  const [lastRefreshed, setLastRefreshed] = useState(null);
  const [newColumns, setNewColumns] = useState([
    {
      name: 'LearnerCell',
      preset: 'LearnerCell',
      filter: {
        type: 'LearnerCell'
      },
      displayName: 'Resident',
      sortOrder: 'none',
      isFilterable: true,
      isSortable: true,
      isVisible: true,
      type: 'preDefined',
      sortByProp: 'learnerUserName'
    },
    {
      name: 'contactName',
      displayName: 'Contact Name',
      sortOrder: 'none',
      isFilterable: true,
      isSortable: true,
      isVisible: true,
      type: 'value',
      sortByProp: 'contactName',
    },
    {
      name: 'contactPhoneNumber',
      displayName: 'Phone Number',
      sortOrder: 'none',
      isFilterable: true,
      isSortable: true,
      isVisible: true,
      type: 'value',
      sortByProp: 'contactPhoneNumber',
    },
    {
      name: 'relationshipType',
      preset: 'MultiTagCell',
      displayName: 'Relationship',
      sortOrder: 'none',
      isFilterable: true,
      isSortable: true,
      isVisible: true,
      type: 'value',
      sortByProp: 'relationshipType',
      filter: {
        type: 'MultiTagCell'
      },
      options: VOICE_CALL.getRelationshipTypes().map(relationship => relationship.value)
    },
    {
      name: 'callType',
      preset: 'IconAndTextCell',
      displayName: 'Call Type',
      sortOrder: 'none',
      isFilterable: true,
      isSortable: true,
      isVisible: true,
      type: 'preDefined',
      sortByProp: 'callType',
      filter: {
        type: 'MultiTagCell'
      },
      options: [
        "VRS",
        "Video",
        "PSTN"
      ]
    },
    {
      name: 'callState',
      preset: 'IconAndTextCell',
      displayName: 'Call State',
      sortOrder: 'none',
      isFilterable: true,
      isSortable: false,
      isVisible: true,
      type: 'preDefined',
      sortByProp: 'status',
      filter: {
        type: 'MultiTagCell'
      },
      options: [
        VOICE_CALL.CALL_HISTORY_STATUS.CANCELLED,
        VOICE_CALL.CALL_HISTORY_STATUS.COMPLETED,
        VOICE_CALL.CALL_HISTORY_STATUS.DECLINED,
        VOICE_CALL.CALL_HISTORY_STATUS.TERMINATED,
        VOICE_CALL.CALL_HISTORY_STATUS.MISSED,
      ]
    },
    {
      name: 'endTimeUtc',
      displayName: 'Call End Time',
      sortOrder: 'none',
      isFilterable: true,
      isSortable: true,
      isVisible: true,
      type: 'value',
      sortByProp: 'endTimeUtc',
    },
    {
      name: 'voiceCallInsights',
      preset: 'MultiTagCell',
      displayName: 'Call Insights',
      sortOrder: 'none',
      isFilterable: true,
      isSortable: false,
      isVisible: true,
      type: 'preDefined',
      sortByProp: 'tags',
      filter: {
        type: 'MultiTagCell'
      },
      options: Object.values(VOICE_CALL.VOICE_INSIGHTS)
        .filter(({ value }) => value !== VOICE_CALL.VOICE_INSIGHTS.VOICE_MATCH_RESIDENT.value)
        .map(({ value }) => value)
    },
    {
      name: 'action',
      displayName: 'Action',
      sortOrder: 'none',
      isFilterable: false,
      isSortable: false,
      isVisible: true,
      type: 'override',
    },
  ]);
  const [callHistoryData, setCallHistoryData] = useState([]);
  const [callHistoryDatasetProps, setCallHistoryDatasetProps] = useState({
    filter: {
      learnerFirstName: "",
      learnerLastName: "",
      learnerDocId: "",
      relationshipType: "",
      contactPhoneNumber: "",
      firstName: "",
      lastName: "",
      voiceCallInsights: ""
    },
    sort: {
      columnName: "endTimeUtc",
      direction: "desc"
    }
  });

  useEffect(() => {
    getCallHistoryData();
  }, [page, defaultPageSize, callHistoryDatasetProps]);

  useEffect(() => {
    if (props.isDataRefresh) {
      refreshTable();
      props.setDataRefresh(false);
    }
  }, [props.isDataRefresh]);

  useEffect(() => {
    if (isV2CallHistoryFlagEnabled) {
      getCallHistoryData();
      return;
    }
    refreshTable();
    props.setShouldExportCallHistory(false);
    props.setDataRefresh(false);
  }, [props.locationId]);

  useEffect(() => {
    if (props.shouldExportCallHistory && totalCount) {
      handleExportCsv(tableColumns);
      props.setShouldExportCallHistory(false);
    }
    if (props.shouldExportCallHistory && !totalCount) {
      handleSnackbar('No data to export', false, 2000);
    }
  }, [props.shouldExportCallHistory, totalCount]);

  const refreshTable = () => {
    tableRef && tableRef.current && tableRef.current.onQueryChange();
  };
  const handleCloseHistoryDetailsModal = () => {
    setDetailModalState(false);
  };
  const onDetailsClick = async (callHistoryData) => {
    setRecordingUrl('');
    setTranscriptData([]);
    setTranscriptSummary({
      main_topics: '',
      inappropriate_violent_themes: [],
    });

    const { meetingId } = callHistoryData;
    setCallDetails(callHistoryData);
    setDetailModalState(true);
    const { preSignedURLAudioRecording, preSignedURLTranscript, privileged, keywords } =
      await voiceCallService.getVoiceCallDetails(meetingId);
    setDetectedKeywords(keywords);
    if (privileged) {
      setIsPrivileged(true);
    } else {
      setIsPrivileged(false);
      setRecordingUrl(preSignedURLAudioRecording);
      getTranscriptData(preSignedURLTranscript);
    }
  };
  const getTranscriptData = async (preSignedURLTranscript) => {
    const transcriptData = await voiceCallService.getVoiceCallTranscription(preSignedURLTranscript);
    if (transcriptData) {
      setTranscriptData(transcriptData);
      setTranscriptSummary((prevState) => ({
        ...prevState,
        main_topics: transcriptData.summary && transcriptData.summary.main_topics ? transcriptData.summary.main_topics : '',
        inappropriate_violent_themes:
          transcriptData.summary && transcriptData.summary.inappropriate_violent_themes
            ? transcriptData.summary.inappropriate_violent_themes
            : [],
      }));
    }
  };

  const setTableFilters = (query) => {
    let filters = { ...stateFilters };
    if (!query) return filters;
    if (!query.filters) return filters;
    for (let i = 0; i < query.filters.length; i++) {
      let item = query.filters[i];
      if (allowedFilters.includes(item.column.field)) {
        let value = item.value;
        if (Array.isArray(value)) value = [...item.value];
        filters[item.column.field] = value;
      }
    }
    return filters;
  };

  const createRequestPayload = (query) => {
    const selectedFilters = setTableFilters(query);
    columnSortByOrderDirection(tableColumns, query.orderBy, query.orderDirection);
    const tbody = {
      endTimeUtc: selectedFilters.endTimeUtc ? moment(selectedFilters.endTimeUtc).format('YYYY-MM-DD') : '',
      learnerFirstName: selectedFilters.learnerFirstName,
      learnerDocId: selectedFilters.learnerDocId,
      relationshipType: selectedFilters.relationshipType,
      contactPhoneNumber: selectedFilters.contactPhoneNumber,
      firstName: selectedFilters.contactName,
      lastName: selectedFilters.contactName,
      voiceCallInsights: selectedFilters.voiceCallInsights.join(),
    };
    let callStatus = Object.values(VOICE_CALL.CALL_HISTORY_STATUS).join().toLowerCase();
    if (selectedFilters.callState.length > 0) {
      callStatus = selectedFilters.callState.join();
    }
    return { tbody, callStatus };
  };

  const getCallHistoryListData = async (query) => {
    if (!props.locationId) return;
    if (!query) return;
    const { orderBy, orderDirection } = query;
    //setQueryForExport(...query);
    // setLoading(true);
    const { tbody, callStatus } = createRequestPayload(query);
    return new Promise((resolve, reject) => {
      voiceCallService
        .getLiveCallsList({
          locationId: props.locationId,
          status: callStatus,
          pageNumber: query.page,
          size: query.pageSize,
          sortBy: orderBy ? orderBy.field : '',
          sortOrder: orderDirection ? orderDirection : '',
          tbody,
        })
        .then((data) => {
          const { content, pageable, totalElements } = data;
          if (content) {
            resolve({
              data: content,
              page: (pageable && pageable.pageNumber) || 0,
              totalCount: totalElements,
            });
            setCallsData(content);
            setTotalCount(totalElements);
          } else reject(new Error('Something went wrong'));
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
        .finally(() => {
          // setLoading(false);
        });
    });
  };
  const exportCallHistoryListData = async () => {
    try {
      if (tableRef && tableRef.current && tableRef.current.state) {
        const { query } = tableRef.current.state;
        const { orderBy, orderDirection } = query;
        const { tbody, callStatus } = createRequestPayload(query);
        const payload = {
          locationId: props.locationId,
          status: callStatus,
          size: totalCount,
          pageNumber: 0,
          tbody,
          sortBy: orderBy ? orderBy.field : '',
          sortOrder: orderDirection ? orderDirection : '',
        };
        const { content } = await voiceCallService.getLiveCallsList(payload);
        if (content) {
          return content;
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleExportCsv = async (tableColumns) => {
    try {
      // const content = await exportCallHistoryListData();
      const content = callHistoryData;
      if (!content || content.length === 0) {
        handleSnackbar('No data to export', false, 2000);
        return;
      }
      const csvContent = generateCsvContent(isV2CallHistoryFlagEnabled ? newColumns : tableColumns, content);
      if (csvContent) {
        generateCsv(csvContent);
        handleSnackbar('CSV file has been exported successfully', true, 2000);
      }
    } catch (error) {
      console.error('Error exporting CSV:', error);
      handleSnackbar('Failed to export CSV', false, 2000);
    }
  };

  const generateCsvContent = (tableColumnsRef, content) => {
    const exemptedColumnsList = ['Actions', 'Action'];
    const csvColumns = [...(isV2CallHistoryFlagEnabled ? newColumns : tableColumnsRef).filter((column) => !exemptedColumnsList.includes(column.title || column.displayName)), {
      title: 'Keywords',
      field: 'keywords'
    }];


    const columnTitles = csvColumns
      .map((column) => column.title || column.displayName)
      .join(',');

    let csvContent = columnTitles + '\r\n';
    const domParser = new DOMParser();

    content.forEach((item) => {
      const rowValues = csvColumns.map((column) => {
        if (column.field || isV2CallHistoryFlagEnabled) {
          let value = getColumnValue(item.rowData, column);
          const document = domParser.parseFromString(value, 'text/html');
          return '"' + document.body.innerText + '"';
        }
        return '';
      });
      const rowString = rowValues.join(',');
      csvContent += rowString + '\r\n';
    });

    return csvContent;
  };

  const getColumnValue = (item, column) => {
    let contactInfo = null;
    try {
      contactInfo = item.contactInfo ? JSON.parse(item.contactInfo) : null;
    } catch (error) {
      console.error('Error parsing contactInfo:', error);
    }

    switch (column.title || column.displayName) {
      case 'Resident':
      case 'Resident Name':
        return `${item.learnerFirstName || ''} ${item.learnerLastName || ''} ${item.learnerDocId || ''}`.trim();
      case 'Phone Number':
        return item.contactPhoneNumber || '';
      case 'Contact Name':
        return contactInfo ? `${contactInfo.firstName || ''} ${contactInfo.lastName || ''}`.trim() : '';
      case 'Relationship':
        return contactInfo ? contactInfo.relationshipType || '' : '';
      case 'Call End Time':
        return item.endTimeUtc || '';
      case 'Call Insights':
        if (!item.voiceCallInsights ||
          item.voiceCallInsights.length === 0 ||
          (item.callState && (
            item.callState === VOICE_CALL.CALL_HISTORY_STATUS.CANCELLED ||
            item.callState === VOICE_CALL.CALL_HISTORY_STATUS.MISSED
          ))) {
          return '';
        }
        // Get unique insights
        const uniqueInsights = [...new Set(item.voiceCallInsights
          .map(event => event.eventType)
          .filter(eventType =>
            VOICE_CALL.VOICE_INSIGHTS &&
            VOICE_CALL.VOICE_INSIGHTS[eventType] &&
            (!VOICE_CALL.VOICE_INSIGHTS.VOICE_MATCH_RESIDENT ||
              VOICE_CALL.VOICE_INSIGHTS[eventType].value !== VOICE_CALL.VOICE_INSIGHTS.VOICE_MATCH_RESIDENT.value)
          )
          .map(eventType => VOICE_CALL.VOICE_INSIGHTS[eventType].label || eventType)
        )];
        return uniqueInsights.join(', ');
      case 'Keywords':
        return item.keywords ? item.keywords.join(', ') : '';
      case 'Call Type':
        return item.callType ? item.callType : '';
      case 'Call State':
        return item.callState ? item.callState : '';
      case 'Relationship':
        return contactInfo ? contactInfo.relationship : '';
      default:
        return item[column.field] || '';
    }
  };

  const generateCsv = (csvContent) => {
    let locationName = getLocationName(props.locationId);
    const exportedFilename = `${locationName} Calls History.csv`;
    const universalBOM = '\uFEFF';
    const downloadLink = document.createElement('a');
    downloadLink.download = exportedFilename;
    downloadLink.href = `data:text/csv;charset=utf-8,${encodeURIComponent(universalBOM + csvContent)}`;
    downloadLink.click();
  };

  /**
   * @name getLocationName
   * @param {number} locationId
   * @desc Based upon locationId it finds in LOCATIONS collection
   * for matching location and shows locationName instead.
   * @return {string}
   */
  const getLocationName = (locationId) => {
    const location = LOCATIONS.find((location) => location.locationId === locationId);
    if (location) {
      return location.locationName;
    } else {
      return '';
    }
  };

  let tableColumns = [
    {
      title: 'Resident Name',
      field: 'learnerFirstName',
      filtering: true,
      sorting: true,
      cellStyle: {
        minWidth: 150,
      },
      render: (rowData) => (
        <Hoverable title={rowData.learnerFirstName}>{rowData.learnerFirstName + ' ' + rowData.learnerLastName}</Hoverable>
      ),
    },
    {
      title: 'DOC ID',
      field: 'learnerDocId',
      filtering: true,
      sorting: true,
      cellStyle: {
        minWidth: 100,
      },
      render: (rowData) => <Hoverable title={rowData.learnerDocId}>{rowData.learnerDocId}</Hoverable>,
    },
    {
      title: 'Contact Name',
      field: 'contactName',
      filtering: true,
      sorting: true,
      render: (rowData) => {
        const { firstName, lastName } = JSON.parse(rowData.contactInfo);
        const fullName = lastName ? `${firstName} ${lastName}` : firstName;
        return <Hoverable title={fullName}>{fullName}</Hoverable>;
      },
    },
    {
      title: 'Phone Number',
      field: 'contactPhoneNumber',
      filtering: true,
      sorting: true,
      render: (rowData) => {
        return <Hoverable title={rowData.contactPhoneNumber}>{rowData.contactPhoneNumber}</Hoverable>;
      },
    },
    {
      title: 'Relationship',
      field: 'relationshipType',
      filtering: true,
      sorting: true,
      render: (rowData) => {
        const { relationshipType } = JSON.parse(rowData.contactInfo);
        return <Hoverable title={relationshipType}>{relationshipType}</Hoverable>;
      },
    },
    {
      title: 'Call End Time',
      field: 'endTimeUtc',
      defaultSort: 'desc',
      type: 'date',
      filtering: true,
      sorting: true,
      render: (rowData) => {
        const endTimeUtc = rowData.endTimeUtc;

        if (endTimeUtc === null) {
          return '';
        }
        const timeZone = getSelectedLocationTimeZone();
        const formattedDate = moment.utc(rowData.endTimeUtc).tz(timeZone).format('MM-DD-YYYY hh:mm:ss A');
        return <Hoverable title={formattedDate}>{formattedDate}</Hoverable>;
      },
    },
    {
      title: 'Call Status',
      field: 'callState',
      filtering: true,
      sorting: false,
      lookup: VOICE_CALL.CALL_HISTORY_STATUS,
      render: (rowData) => (
        <Typography className={VOICE_CALL.getCallStatusClassName(rowData.callState, props.classes)}>
          {' '}
          {VOICE_CALL.capitalizeFirstLetter(rowData.callState)}
        </Typography>
      ),
    },
    ...(isKeywordFlagEnabled
      ? [
        {
          title: 'Call Insights',
          field: 'voiceCallInsights',
          filtering: true,
          lookup: Object.fromEntries(
            Object.values(VOICE_CALL.VOICE_INSIGHTS)
              .filter(({ value }) => value !== VOICE_CALL.VOICE_INSIGHTS.VOICE_MATCH_RESIDENT.value)
              .map(({ value, label }) => [value, label])
          ),
          sorting: false,
          render: (rowData) => {
            const { voiceCallInsights } = rowData;

            if (
              !voiceCallInsights ||
              voiceCallInsights.length === 0 ||
              rowData.callState === VOICE_CALL.CALL_HISTORY_STATUS.CANCELLED ||
              rowData.callState === VOICE_CALL.CALL_HISTORY_STATUS.MISSED
            ) {
              return null; // No insights to display
            }

            // Collect unique events using a Set for event types
            const uniqueInsights = [];
            const seenEventTypes = new Set();

            for (const event of voiceCallInsights) {
              if (!seenEventTypes.has(event.eventType)) {
                uniqueInsights.push(event);
                seenEventTypes.add(event.eventType);
              }
            }

            return (
              <>
                {uniqueInsights
                  .filter(
                    (event) =>
                      VOICE_CALL.VOICE_INSIGHTS[event.eventType] &&
                      VOICE_CALL.VOICE_INSIGHTS[event.eventType].value !==
                      VOICE_CALL.VOICE_INSIGHTS.VOICE_MATCH_RESIDENT.value
                  )
                  .map((event, index) => (
                    <Box key={index}>
                      <VoiceInsightChip
                        label={VOICE_CALL.VOICE_INSIGHTS[event.eventType]?.label}
                        className={rowData?.callType === 'VRS' ? 'vrs' : ''}
                      />
                    </Box>
                  ))}
              </>
            );
          },
        },
      ]
      : []),
    {
      title: 'Actions',
      sorting: false,
      filtering: false,
      render: (rowData) => {
        if (
          [VOICE_CALL.CALL_HISTORY_STATUS.COMPLETED, VOICE_CALL.CALL_HISTORY_STATUS.TERMINATED].includes(rowData.callState)
        ) {
          return (
            <Button onClick={() => onDetailsClick(rowData)} style={{ fontWeight: 'bold' }}>
              Details
            </Button>
          );
        }
      },
    },
  ];

  const parseJoinDateIfValid = (endTimeUtc) => {
    if (endTimeUtc && moment(endTimeUtc).isValid()) {
      return moment(endTimeUtc).format('MM-DD-YYYY hh:mm:ss A');
    }
    return '';
  };

  const handleSnackbar = (message, success, duration) => {
    setSnackbarMessage(message);
    setOpenSnackbar(true);
    setSnackbarAutoHideDuration(duration);
    setIsSuccessSnackbar(success);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  // V2
  const formatLastRefreshedTime = (timestamp) => {
    if (!timestamp) return '';

    const options = {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };

    return `Last Refreshed ${timestamp.toLocaleTimeString('en-US', options)}`;
  };

  const onPageChange = (page) => {
    setPage(page);
  };

  const onPageSizeChange = (pageSize) => {
    setPage(1);
    setDefaultPageSize(pageSize)
  };

  const onSortChange = (columnName, direction) => {
    const mapping = {
      'LearnerCell': 'learnerUserName',
    }
    setCallHistoryDatasetProps({
      ...callHistoryDatasetProps,
      sort: {
        columnName: mapping[columnName] || columnName,
        direction
      }
    });
  };

  const onFilterChange = (filters) => {
    let tempFilters = {
      learnerFirstName: "",
      learnerLastName: "",
      learnerDocId: "",
      relationshipType: "",
      contactPhoneNumber: "",
      firstName: "",
      lastName: "",
      voiceCallInsights: "",
      contactName: ""
    };
    const mapping = {
      "username": "learnerUserName",
      "firstName": "learnerFirstName",
      "lastName": "learnerLastName",
      "docId": "learnerDocId"
    }
    filters.forEach((filter) => {
      if (tempFilters[mapping[filter.preDefinedPropName] || filter.columnName]) {
        tempFilters[mapping[filter.preDefinedPropName] || filter.columnName] += "%" + filter.value + "%,";
      } else {
        tempFilters[mapping[filter.preDefinedPropName] || filter.columnName] = "%" + filter.value + "%,";
      }
      if (filter.columnName == "voiceCallInsights") {
        tempFilters[filter.columnName] = filter.value
          .split(",")
          .map(item => item.trim())
          .join(",")
      }
      if (filter.columnName == "relationshipType") {
        tempFilters[filter.columnName] = filter.value
          .split(",")
          .map(item => item.trim())
          .join(",");
      }
    });
    setPage(1);
    setCallHistoryDatasetProps({
      ...callHistoryDatasetProps,
      filter: tempFilters,
    });
  };

  /**
   * 
   * Parses the JSON & returns the value. Return empty string if NO value is found
   * @param {string} contactInfo in JSON Stringified form
   * @return string 
   */
  const extractContactInfo = (contactInfo, property) => {
    if (contactInfo) {
      const parsedData = JSON.parse(contactInfo);
      return parsedData[property] || '';
    }
    return '';
  };

  const mapToCallHistory = (data) => data.map((item) => ({
    isSelected: false,
    rowData: {
      id: item.meetingId,
      contactName: `${extractContactInfo(item.contactInfo, 'firstName')} ${extractContactInfo(item.contactInfo, 'lastName')}`,
      contactPhoneNumber: item.contactPhoneNumber,
      relationshipType: extractContactInfo(item.contactInfo, 'relationshipType'),
      callType: item.callType,
      callState: item.callState,
      endTimeUtc: item.endTimeUtc ? moment.utc(item.endTimeUtc).tz(getSelectedLocationTimeZone()).format('MM-DD-YYYY hh:mm:ss A') : '',
      action: () => (
        <>
          {[VOICE_CALL.CALL_HISTORY_STATUS.COMPLETED, VOICE_CALL.CALL_HISTORY_STATUS.TERMINATED].includes(item.callState) && (
            <Button
              onClick={() => onDetailsClick(item)}
              sx={ViewDetailStyles}>
              View Details
            </Button>
          )}
        </>
      ),
      // DATA REQUIRED FOR CSV EXPORT
      voiceCallInsights: item.voiceCallInsights,
      learnerUserName: item.learnerUserName,
      learnerFirstName: item.learnerFirstName,
      learnerLastName: item.learnerLastName,
      learnerDocId: item.learnerDocId,
      keywords: item.keywords,
      contactInfo: item.contactInfo

    },
    preDefineComponentProps: {
      voiceCallInsights: {
        tags: getVoiceInsights(item.voiceCallInsights, item.callState).map((voiceInsight) => ({
          label: VOICE_CALL.VOICE_INSIGHTS[voiceInsight.eventType]?.label,
          color: 'warning',
          size: 'small',
          variant: 'filled',
          sx: {
            backgroundColor: item.callType == 'VRS' ? '#FFF7E3' : '#FFECF0',
            color: item.callType == 'VRS' ? 'var(--yellow-deep)' : '#7C0E22',
            border: item.callType == 'VRS' ? '1px solid var(--yellow-main)' : '1px solid #E32D4E',
          },
        }))
      },
      LearnerCell: {
        username: item.learnerUserName,
        firstName: item.learnerFirstName,
        lastName: item.learnerLastName,
        docId: item.learnerDocId,
      },
      callState: getCallStatusComponents(item.callState),
      callType: getCallType(item.callType)
    }
  }))

  const getCallHistoryData = async () => {
    try {
      setLoading(true);
      let callStatus = Object.values(VOICE_CALL.CALL_HISTORY_STATUS).join().toLowerCase();
      if (callHistoryDatasetProps.filter.hasOwnProperty("callState")) {
        callStatus = callHistoryDatasetProps.filter.callState
          .toLowerCase()
          .split(",")
          .map(item => item.trim().replaceAll('%', ''))
          .join(",");
      }
      const liveCallData = await voiceCallService.getLiveCallsList({
        locationId: props.locationId,
        status: callStatus,
        pageNumber: page - 1,
        size: defaultPageSize,
        sortBy: callHistoryDatasetProps.sort.columnName,
        sortOrder: callHistoryDatasetProps.sort.direction,
        tbody: callHistoryDatasetProps.filter,
      });

      const transformedData = mapToCallHistory(liveCallData.content);
      setTotalCount(liveCallData.totalElements);
      setCallHistoryData(transformedData);
      setLastRefreshed(new Date());
    } catch (e) {
      console.log(e);
      handleSnackbar("Something went wrong, please reload the page!", "error", 2000);
    } finally {
      setLoading(false);
    }
  };

  const onRefreshHandler = () => {
    getCallHistoryData();
  };

  return {
    callHistoryData,
    newColumns,
    tableColumns,
    callsData,
    isLoading,
    defaultPageSize,
    totalCount,
    isDetailModalOpen,
    callDetails,
    recordingUrl,
    callStatus,
    transcriptData,
    transcriptSummary,
    detectedKeywords,
    lastRefreshed,
    handleCloseHistoryDetailsModal,
    openSnackbar,
    snackbarMessage,
    snackbarAutoHideDuration,
    isSuccessSnackbar,
    handleCloseSnackbar,
    getCallHistoryListData,
    exportCallHistoryListData,
    tableRef,
    handleExportCsv,
    generateCsvContent,
    generateCsv,
    parseJoinDateIfValid,
    getLocationName,
    getColumnValue,
    isPrivileged,
    formatLastRefreshedTime,
    onPageChange,
    onPageSizeChange,
    onSortChange,
    onFilterChange,
    onRefreshHandler
  };
};
